<div class="callout-text">
  {{ translationPrefix() + 'heading' | translate }}
</div>

<div class="accordion-wrapper">
  @for (faqItem of faqData(); track faqItem.question) {
    <p-accordion>
      <p-accordion-panel value="0">
        <p-accordion-header>
          {{faqItem.question}}
        </p-accordion-header>
        <p-accordion-content>
          {{faqItem.answer}}
          @if (faqItem.additionalList) {
            <br>
            <ul>
              @for(faqItemAdditional of faqItem.additionalList; track faqItemAdditional){
                <li>
                  {{faqItemAdditional}}
                </li>
              }
            </ul>
          }
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  }
</div>
